"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IOSInterruptionLevel = void 0;
var IOSInterruptionLevel;
(function (IOSInterruptionLevel) {
    IOSInterruptionLevel["PASSIVE"] = "passive";
    IOSInterruptionLevel["ACTIVE"] = "active";
    IOSInterruptionLevel["TIME_SENSITIVE"] = "time_sensitive";
    IOSInterruptionLevel["CRITICAL"] = "critical";
})(IOSInterruptionLevel = exports.IOSInterruptionLevel || (exports.IOSInterruptionLevel = {}));
//# sourceMappingURL=ios-interruption-level.js.map